// i18n area 'vms' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.hu-HU.meta.json.
import type { enUS } from './vms'

export const huHU: typeof enUS = {
  vms: {
    spof: {
      title: 'Függetlenség a csomóponttól',
      single: 'Egyetlen hibapont',
      alternativesNow: 'Alternatívák most',
      structural: 'Konstrukció szerint',
      binding: 'Korlátozó feltétel',
      movableNow: 'Migráció lehetséges most',
    },
    title: 'Virtuális gépek',
    migratingChip: 'Migráció folyamatban',
    templateChip: 'Sablon',
    expendableTooltip: 'Degradált klaszterben az elsők között esik el, és egy csomópont elvesztése után lehet, hogy nem indul újra.',
    expendableHaTooltip: 'Amíg a klaszter egészséges, mindig újraindul; degradált klaszterben a védett VM-ek élveznek elsőbbséget — leállítható vagy kikapcsolva maradhat, amíg a klaszter újra teljes nem lesz, aztán magától elindul.',
    viewDetails: 'Részletek megtekintése',
    profileLegacy: 'Egyéb OS',
    hugePagesNone: 'Nincs — normál memória',
    hugePages2M: '2 MiB-os lapok',
    hugePages1G: '1 GiB-os lapok',
    searchPlaceholder: 'Keresés név szerint',
    name: 'Név',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Memória',
    ipAddresses: 'IP-címek',
    noIp: 'Nincs IP',
    authorityNode: 'Authority',
    authorityNextStart: 'a következő indításkor lesz kiosztva',
    scope: 'Scope',
    empty: 'Nincs virtuális gép',
    loadError: 'A virtuális gépek nem tölthetők be — elérhető a TVirt backend?',
    filterOverlay: 'overlay-hálózat',
    filterDisk: 'lemez',
    filterImage: 'lemezkép',
    filteredBy: 'Szűrve erre: {kind}',
    filterPhase: 'Fázis',
    filterProtection: 'Védelem',
    filterAll: 'Mind',
    filterScopePlaceholder: 'Szűrés scope szerint',
    filtersToggle: 'Szűrők',
    scopeTree: {
      title: 'Scope',
      all: 'A teljes klaszter',
      noChildren: 'Itt nincs al-scope',
      recursive: 'Leszármazottakkal együtt',
      collapse: 'A scope-panel összecsukása',
      up: 'Egy szinttel feljebb',
      countTooltip: '{direct} VM ebben a scope-ban · {total} a leszármazottakkal'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Katalógus',
      unknownCatalog: 'A látható katalógusokon kívül',
      noIsos: 'Nincs kész ISO-lemezkép ebben a katalógusban'
    },
    actionsHeader: 'Műveletek',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardver',
      tags: 'Címkék',
      age: 'Kor',
      disk: 'lemez',
      disks: 'lemez',
      empty: 'Nincs sablon — jelölj meg sablonként egy kikapcsolt VM-et, vagy klónozz egy VM-et sablonként.',
      clone: 'Klónozás / deploy',
      editTags: 'Címkék szerkesztése',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Exportálás a katalógusba (.tvtpl)',
      exportTitle: 'Exportálás a katalógusba',
      exportSubmit: 'Exportálás',
      exportError: 'Az exportálás nem sikerült',
      exportHint: 'A sablon egy .tvtpl archívumba csomagolódik (hardver-manifest + minden lemez qcow2-be lapítva), új VM-sablon fájlként a kiválasztott katalógusban. A NIC-ek, a CD/DVD-adathordozók és a cloud-init nem utaznak — a formátum specifikációja minden szándékos kihagyást felsorol.',
      exportName: 'A fájl neve',
      exportNameHint: 'Üresen = <template>-export-<n>',
      exportStorageDefault: 'A sablon metaadat-tárolója',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Importálás katalógusból',
      importTitle: 'Importálás katalógusból',
      importHint: 'A kiválasztott katalógus egy ready állapotú VM-sablon fájljából az inventár sablonja lesz: a fájl formátuma (tvtpl, ova, ovf vagy csupasz qcow2) magától eldönti, hogyan importálódik — te csak a fájlt választod ki.',
      importFile: 'Katalógusfájl',
      importFileHint: 'Csak ready fájlok importálhatók — egy félig feltöltött nem az',
      importNoFiles: 'Nincs ready VM-sablon fájl ebben a katalógusban — előbb tölts fel vagy exportálj egyet'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-kompatibilitás',
      quickDeployNone: 'Nincs deklarálva',
      quickDeployHint: 'Csak akkor deklarálja, ha a golden lemezkép tartalmazza a cloud-initet (Linux) vagy a cloudbase-initet sysprep /generalize után (Windows): a platform megbízik a deklarációban, és soha nem néz bele a vendégbe.',
      notFound: 'A sablon nem található',
      frozen: 'A hardverkonfiguráció be van fagyasztva: a módosításához alakítsd vissza a sablont VM-mé. A név, a jegyzetek és a címkék módosíthatók maradnak.',
      storage: 'Tároló',
      size: 'Méret',
      configTitle: 'Konfiguráció (befagyasztva)',
      usbClasses: 'Kért USB-osztályok',
      gpuClasses: 'Kért GPU-osztályok'
    },
    sharedDisksTab: {
      title: 'Megosztott lemezek',
      sharing: 'Megosztás',
      sharingNone: 'Egyetlen csatolás',
      sharingMultiwriter: 'Megosztott írás (multiwriter)',
      sharingReadonly: 'Megosztott csak olvasás',
      usedBy: 'Használja',
      attachedTo: 'Csatolva ehhez',
      notAttached: 'Egy VM-hez sincs csatolva',
      changeSharing: 'Megosztási mód módosítása',
      changeSharingTitle: 'Megosztási mód',
      changeSharingLocked: 'A mód csak akkor változtatható, amíg egyetlen VM sem használja a lemezt',
      sharingChanged: 'Megosztási mód frissítve.',
      lun: 'Teljes LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Sorozatszám',
      antiAffinityWarning: 'Két vagy több tag fut ugyanazon a csomóponton anti-affinitási szabály nélkül: egy csomópont kiesése mindet leviszi',
      antiAffinityCreate: 'Szabály létrehozása',
      createSourceLun: 'A target egy teljes LUN-jának átvétele',
      createLunNumber: 'LUN-szám (namespace-azonosító NVMe-n)',
      createLunHint: 'Semmi sem kerül lefoglalásra: a méret átvételkor az eszközről olvasódik',
      noPr: 'Ebben a kiadásban nincs SCSI-3 persistent reservation: a klasszikus megosztott lemezes Windows Failover Cluster nincs validálva; a hálózaton koordináló fürtök (GFS2/OCFS2, RHEL HA, shared-disk adatbázisok) igen'
    },
    unusedDisksTab: {
      title: 'Nem használt lemezek',
      attach: 'Csatlakoztatás egy VM-hez',
      attachTitle: 'Csatlakoztatás egy VM-hez',
      vm: 'Virtuális gép',
      noVms: 'Nincs elérhető VM',
      noSlots: 'Nincs szabad slot ezen a VM-en',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Lemez létrehozása',
      createTitle: 'Lemez létrehozása',
      createSourceBlank: 'Üres lemez',
      createSourceImage: 'Katalógusbeli lemezképből',
      createImage: 'Lemezkép',
      createImageEmpty: 'Nincs kész VM-sablon lemezkép a látható katalógusokban',
      createSizeFromImageHint: 'A lemezkép virtuális méretével előre kitöltve — csak nőhet',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Konvertálás VM-sablonná…',
      convertOnlyQcow2: 'Csak qcow2 lemezek konvertálhatók — a raw nem regisztrálható sablonformátum',
      convertTitle: 'Konvertálás VM-sablonná',
      convertSubmit: 'Konvertálás (megsemmisíti a lemezt)',
      convertError: 'A konverziót nem sikerült elindítani',
      convertWarning: 'DESTRUKTÍV: a lemezből VM-sablon fájl lesz a kiválasztott katalógusban — ugyanaz a tároló, nulla bájt másolva —, és lemezként MEGSZŰNIK LÉTEZNI. Visszaút nincs, csak új lemezt lehet létrehozni a sablonból.',
      convertNameHint: 'A katalógusfájl neve — alapból a lemezé',
      convertConfirm: 'Megértettem: a lemez meg lesz semmisítve',
      convertStarted: 'Konverzió elindítva — a sablon a feladat végén jelenik meg a katalógusban.',
      storageLockHint: 'A tároló csak az Áthelyezés művelettel változik',
      source: 'Eredet',
      sourceClone: 'Egy másik lemez klónja',
      sourceCloneLinked: 'Egy másik lemez linked clone-ja',
      sourceImage: 'Lemezképből létrehozva',
      sourceBlank: 'Üresen létrehozva',
      allocated: 'Lefoglalt / virtuális méret',
      observedAt: 'Megfigyelve',
      snapshots: 'Pillanatképek',
      snapshotsEmpty: 'Nincs pillanatkép'
    },
    phase: {
      defined: 'Még sosem indult',
      starting: 'Indul',
      running: 'Fut',
      stopping: 'Leáll',
      stopped: 'Kikapcsolva',
      paused: 'Szüneteltetve',
      failed: 'Hibaállapotban',
      deleting: 'Törlés alatt'
    },
    stopCause: {
      'api': 'A TVirt állította le (művelet vagy API)',
      'guest-shutdown': 'A guest operációs rendszer által indított leállítás',
      'crash': 'A guest összeomlott',
      'qemu-exit': 'A QEMU-folyamat váratlanul kilépett',
      'host-reboot': 'A csomópont újraindult',
      'migrated': 'Másik csomópontra migrálva',
      'fenced': 'A HA-fencing terminálta (a csomópont visszatért)'
    },
    detail: {
      notFound: 'A virtuális gép nem található',
      details: 'Részletek',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardverprofil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmware-verzió',
      firmwareUpdate: 'Frissítés érhető el',
      firmwareUpdateHint: 'A platform újabb UEFI-firmware-t szállít. A frissítés sosem automatikus: kikapcsolt VM-en történik, amikor te úgy döntesz.',
      arch: 'Architektúra',
      node: 'Csomópont',
      bootOrder: 'Bootsorrend',
      agent: 'Agent állapota',
      agentConnected: 'Kapcsolódva',
      agentNotConnected: 'Nincs kapcsolódva',
      protected: 'Védett',
      linkedClones: 'Kapcsolt klónok',
      restartPolicy: 'Újraindítási szabályzat',
      preferredNode: 'Preferált csomópont',
      noPreference: 'Nincs preferencia (automatikus elhelyezés)',
      preferNodes: 'Preferált csomópontcímkék',
      requireNodes: 'Kötelező csomópontcímkék',
      noPlacementTags: 'Nincs',
      placementTag: 'Címke',
      placementValue: 'Érték',
      placementAddTag: 'Címke hozzáadása',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA-újraindítás',
      proximityHaGaveUp: 'crash loop — a HA feladta',
      failoverProtection: 'Védelem degradált állapotban',
      protectionProtected: 'Védett',
      protectionExpendable: 'Degradáltan feláldozható',
      protectionInherit: 'Öröklés',
      lastStop: 'Utolsó leállás',
      yes: 'Igen',
      no: 'Nem',
      tabOverview: 'Áttekintés',
      tabSnapshots: 'Pillanatképek',
      tabBackups: 'Mentések',
      hardware: 'Hardver',
      name: 'Név',
      hwSystem: 'Rendszer',
      hwCpu: 'CPU',
      hwMemory: 'Memória',
      hwBoot: 'Indítás',
      hwIdentity: 'Identitás',
      hwCluster: 'Klaszter és agent',
      cpuTopology: 'CPU-topológia',
      cpuModel: 'CPU-modell',
      cpuLimit: 'CPU-korlát',
      cpuWeight: 'CPU-súly',
      cpuNested: "Beágyazott virtualizáció",
      cpuNestedHint: "A vendég számára elérhetővé teszi a vmx/svm-et (csak host CPU-modellel). Futó VM-en a módosítás a következő power cycle-nél lép életbe (PendingRestart); az elhelyezés csak nested-et engedélyező csomópontokat fogad el.",
      unlimited: 'Korlátlan',
      memory: 'Memória',
      balloon: 'Balloon',
      hugePages: 'Óriáslapok',
      hugePagesTradeoff: 'Kevesebb címfordítási munka, és a memória sosem kerül lemezre; cserébe a foglalás a csomóponton marad lekötve, amíg a VM be van kapcsolva, a memória többé nem deduplikálódik, és az indítás elbukik, ha a csomóponton nincs elég szabad lap.',
      disks: 'Lemezek',
      cdroms: 'CD/DVD-meghajtók',
      nics: 'Hálózati interfészek',
      slot: 'Slot',
      disk: 'Lemez',
      encrypted: 'Titkosítva',
      image: 'Lemezkép',
      emptyDrive: 'Üres meghajtó',
      emptyOption: '(üres)',
      network: 'Hálózat',
      mac: 'MAC',
      connected: 'Csatlakoztatva',
      unplugged: 'Lecsatlakoztatva',
      noDevices: 'Nincs',
      screenshot: 'Képernyőkép',
      capturedAt: 'Rögzítve',
      noCapture: 'Nincs felvétel',
      snapshotName: 'Név',
      snapshotCreated: 'Létrehozva',
      snapshotMemory: 'Memóriával együtt',
      noSnapshots: 'Nincs pillanatkép',
      pendingRestart: 'Függő módosítások: a következő power cycle-nél lesznek alkalmazva.',
      applied: 'alkalmazva',
      appliedHint: 'A VM ezzel az értékkel fut — a konfigurált a következő power cycle-nél lép életbe.',
      actionError: 'A művelet nem sikerült',
      actionStillRunning: 'A művelet még folyamatban van: az eredmény még nem ismert',
      tabConsole: 'Konzol',
      consoleConnect: 'Kapcsolódás',
      consoleDisconnect: 'Kapcsolat bontása',
      consoleConnecting: 'Kapcsolódás…',
      consoleReconnecting: 'Kapcsolódás…',
      consoleUnavailable: 'A konzol futó vagy szüneteltetett VM-mel érhető el.',
      consoleError: 'A konzolhoz nem sikerült kapcsolódni',
      consoleTaken: 'A konzolmunkamenetet átvette: {user}',
      consoleReconnect: 'Újrakapcsolódás',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: '{key} nyomva tartása',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Megnyitás teljes képernyőn, új lapon',
      consoleLoadFailed: 'A VM nem található, vagy nincs elég jogosultság',
      consoleClose: 'Bezárás',
      tabStats: 'Statisztikák',
      tabTasks: 'Feladatok',
      tabLogs: 'Napló',
      statsCpu: 'CPU',
      statsMemory: 'Memória',
      statsDisk: 'Lemez-I/O',
      statsRange: 'Intervallum',
      statsNoData: 'Nincs adat az intervallumban — a statisztikák futó VM mellett mintavételeződnek.',
      statsError: 'A statisztikák nem tölthetők be',
      cpuUsage: 'Kihasználtság',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Használt',
      memGuestAvailable: 'Elérhető (guest)',
      schema: 'Séma',
      consoleProtocol: 'Konzol',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Metaadat-tároló',
      startupOnBoot: 'Indítás bootkor',
      startupOrder: 'Indítási sorrend',
      startupDelay: 'Indítási késleltetés',
      seconds: 's',
      enabled: 'Engedélyezve',
      disabled: 'Letiltva'
    },
    actionsAvailable: 'Elérhető műveletek',
    actions: {
      start: 'Indítás',
      stop: 'Leállítás',
      pause: 'Szüneteltetés',
      resume: 'Folytatás',
      reset: 'Reset',
      migrate: 'Migrálás',
      clone: 'Klónozás',
      moveStorage: 'Áthelyezés tárolóra…',
      moveScope: 'Áthelyezés scope-ba…',
      openConsole: 'Konzol megnyitása',
      forceStop: 'Kényszerített kikapcsolás',
      markTemplate: 'Megjelölés sablonként',
      unmarkTemplate: 'Visszaalakítás VM-mé',
      error: 'A műveletet nem sikerült végrehajtani'
    },
    cordon: {
      confirmTitle: 'A csomópont karbantartás alatt áll',
      confirmHint:
        'A kordont nem lehet leengedni, amíg a fürt store-ja nem érhető el. A megerősítéssel kijelented, hogy tudsz róla: a VM ott mindenképp elindul, és a hozzájárulás rögzítve marad a feladaton.',
      confirm: 'Indítsd el mégis'
    },
    markTemplate: {
      confirmTitle: 'Sablonná jelölöd: {name}?',
      confirmBody: 'A konfiguráció befagy, és a VM többé nem kapcsolható be — csak klónozható, vagy visszaalakítható VM-mé. A név, a jegyzetek és a címkék módosíthatók maradnak.',
      confirm: 'Megjelölés sablonként',
      moved: 'A(z) {name} mostantól sablon — átkerült a Sablonok lapra.'
    },
    unmarkTemplate: {
      confirmTitle: 'Visszaalakítod VM-mé: {name}?',
      confirmBody: 'A sablon újra közönséges VM lesz: módosítható és indítható (a következő indítás elhelyezi egy csomóponton).',
      confirm: 'Visszaalakítás VM-mé',
      moved: 'A(z) {name} újra virtuális gép — átkerült a Virtuális gépek lapra.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Csomópontcímke szerint',
      hint: 'címke=érték, vesszővel elválasztva (ÉS-kapcsolatban): a decider a megfelelő csomópontok közül választ',
      invalid: 'Érvénytelen formátum — használj címke=érték párokat, vesszővel elválasztva',
      resolved: 'Megfelelő tagok: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migrálás',
      target: 'Célcsomópont',
      auto: 'Automatikus (Proximity)',
      hint: 'A VM power cycle nélkül költözik. Minden tárolónak, amelyet érint, megosztottnak kell lennie; egy szüneteltetett VM szüneteltetve migrál.',
      error: 'A migráció el lett utasítva'
    },
    moveStorage: {
      title: 'Áthelyezés tárolóra',
      submit: 'Áthelyezés',
      target: 'Céltároló',
      noTargets: 'Egyetlen tároló sem fogad lemezeket',
      hint: 'A kikapcsolt VM összes lemeze a kiválasztott tárolóra utazik, egyesével, megőrizve az id-jét — a már célban lévők kimaradnak. Az előrehaladás a feladatok oldalán él.',
      error: 'Az áthelyezés el lett utasítva'
    },
    moveScope: {
      title: 'Áthelyezés scope-ba',
      submit: 'Áthelyezés',
      target: 'Cél-scope',
      hint: 'A VM azonnal scope-ot vált — az id és a lemezek maradnak, a birtokolt lemezek követik, és bekapcsolva maradhat. Ma itt él: {scope}. Hogy ki látja, a scope-pal együtt változik.',
      error: 'A scope-váltás el lett utasítva'
    },
    start: {
      title: 'VM indítása',
      submit: 'Indítás',
      target: 'Célcsomópont',
      auto: 'Automatikus (ajánlott)',
      recommended: 'ajánlott',
      hint: 'Válassz célcsomópontot, vagy hagyd, hogy a Proximity döntsön az érvényes jelöltek közül. Azok a csomópontok, amelyek nem tudják befogadni, le vannak tiltva, az okkal együtt.',
      error: 'A VM-et nem sikerült elindítani'
    },
    console: {
      media: 'CD/DVD-meghajtók',
      mediaGuestToolsHint: 'A TVirt Guest Toolst tartalmazza — innen kiadhatod, vagy eltávolíthatod a meghajtót',
      slotOpsDeferred: 'Ezen a profilon a meghajtók hozzáadása és eltávolítása a következő power cycle-nél lép életbe (az adathordozó-cserék azonnaliak).',
      mountGuestTools: 'TVirt Guest Tools csatolása',
      ejectGuestTools: 'TVirt Guest Tools kiadása',
      bootOrder: 'Bootsorrend',
      bootOrderHint: 'Az új sorrend azonnal mentődik, és a következő power cycle-nél lép életbe — a konzolmunkamenet kapcsolódva marad.'
    },
    snapshots: {
      create: 'Pillanatkép létrehozása',
      createTitle: 'Pillanatkép létrehozása',
      createSubmit: 'Létrehozás',
      name: 'Név',
      nameHint: 'Betűk, számjegyek, pont, kötőjel, aláhúzás.',
      consistencyHint: 'A konzisztencia automatikus: a guest agent befagyasztja a fájlrendszereket, ha válaszol; különben a VM a pillanatkép körül egy pillanatra szünetel.',
      memory: 'A memóriával együtt',
      memoryHint: 'Rögzíti az élő RAM-ot: a visszaállítás futó állapotban folytatja a VM-et. Minden lemeznek qcow2-nek kell lennie.',
      currentChip: 'Itt vagy',
      revert: 'Visszaállítás',
      revertTitle: 'Visszaállítod: {name}?',
      revertBody: 'A lemezek a pillanatkép állapotára térnek vissza; minden, ami utána történt, elvész. Egy csak-lemezes pillanatképhez a VM-nek leállítva kell lennie.',
      delete: 'Törlés',
      deleteTitle: 'Törlöd a(z) {name} pillanatképet?',
      deleteBody: 'A visszaállítási pont eltűnik; a lemezek tartalma érintetlen marad.',
      deleteMergeHint: 'A deltája beolvad ide: {children}; minden későbbi visszaállítási pont érvényes marad.',
      deleteDuplication: 'Elfogadom a duplikációt',
      deleteDuplicationHint: 'A delta bemásolódik mind a {count} olvasóba (a gyermek snapshotok és, ha ez az aktuális, az aktív fej): a foglalt hely nőhet csökkenés helyett.',
      error: 'A pillanatkép-műveletet a rendszer elutasította'
    },
    clone: {
      title: 'VM klónozása',
      submit: 'Klónozás',
      name: 'A másolat neve',
      storage: 'A lemezek céltárolója',
      sameStorage: 'Ugyanaz, mint a forrásé',
      full: 'Teljes másolat',
      fullHint: 'Minden bájtot lemásol, és elvágja a kapcsolatot a forráslemezekkel. A default a linked clone: azonnali, de a forráshoz láncolt (csak qcow2).',
      hint: 'A klón megtartja a forrás konfigurációját és firmware-ét; a MAC-címek és a TPM-identitás újak.',
      markAs: 'A klón típusa',
      markAsInheritVm: 'Mint a forrás (VM)',
      markAsInheritTemplate: 'Mint a forrás (sablon)',
      markAsVm: 'Virtuális gép',
      markAsTemplate: 'Sablon',
      markAsHintVm: 'Válaszd a Sablont, hogy a másolatot egyetlen lépésben előléptesd.',
      markAsHintTemplate: 'Válaszd a Virtuális gépet, hogy ebből a sablonból egyetlen lépésben deployolj.',
      error: 'A klónozás el lett utasítva'
    },
    bulk: {
      selected: 'kijelölve',
      deleteTitle: {
        one: 'Törlöd a kijelölt {count} VM-et?',
        other: 'Törlöd a kijelölt {count} VM-et?'
      },
      deleteBody: 'Minden VM ugyanazokon az őrökön megy át, mint az egyedi törlés; az elutasítások elemenként jelennek meg.',
      done: 'elfogadva',
      refused: 'elutasítva'
    },
    delete: {
      button: 'Törlés',
      confirmTitle: 'Törlöd: {name}?',
      confirmBody: 'A virtuális gép és a tulajdonában lévő lemezek törlődni fognak. A művelet nem visszafordítható.',
      keepDisks: 'A lemezek megtartása',
      keepDisksHint: 'A VM-mel létrehozott lemezek önálló lemezekként a tárolójukon maradnak.',
      confirm: 'Törlés',
      cancel: 'Mégse',
      error: 'A törlés nem sikerült',
      blockedPhase: 'Előbb állítsd le a VM-et',
      blockedProtected: 'A VM védett — előbb távolítsd el a védelmet',
      blockedDeleting: 'A törlés már folyamatban van'
    },
    logs: {
      title: 'Napló',
      subtitle: 'Strukturált naplókeretek azokból a feladatokból, amelyek ezt a VM-et érintik',
      when: 'Mikor',
      task: 'Feladat',
      level: 'Szint',
      message: 'Üzenet',
      empty: 'Még nincs napló',
      loadError: 'A napló nem tölthető be — elérhető a TVirt backend?'
    },
    stop: {
      title: 'Virtuális gép leállítása',
      modeGraceful: 'Graceful leállítás',
      modeGracefulHint: 'A guest operációs rendszert kérjük meg, hogy természetes módon álljon le (ACPI); ha figyelmen kívül hagyja a kérést, a timeout után jön a kényszerített kikapcsolás.',
      modeForced: 'Kényszerített kikapcsolás',
      modeForcedHint: 'Azonnal elvágja az áramot, mintha kihúznád a dugót.',
      timeout: 'Tartalék-timeout (másodperc)',
      timeoutHint: 'A guestnek engedett várakozás a kikapcsolás kikényszerítése előtt'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'A nulláról',
    createFromTemplate: 'Sablonból',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Deploy végrehajtása',
      error: 'A deploy nem sikerült',
      compatNote: 'A QuickDeploy QuickDeploy-kompatibilis sablont igényel: a platform az első indításkor testre szabja a vendéget (hálózat, tartomány, aktiválás).',
      template: 'Sablon',
      noTemplates: 'Még egyetlen sablon sem deklarál QuickDeploy-kompatibilitást — deklarálja a Sablonok lapon (Linux cloud-inittel, Windows cloudbase-inittel sysprep után)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Gazdagépnév',
      hostnameHint: 'Gazdagépnév vagy FQDN; üres = a VM neve (Windows: legfeljebb 15 karakter)',
      ip: 'IP-cím',
      ipHint: 'Gazdagép és előtag, pl. 192.168.122.101/24; üres = DHCP',
      gateway: 'Átjáró',
      dns: 'DNS-kiszolgálók',
      dnsHint: 'Legfeljebb három, vesszővel elválasztva',
      count: 'Példányok',
      countHint: 'Egynél több: nevük <név>-1…-N, csak DHCP',
      user: 'Felhasználó',
      userHint: 'Üres = a lemezkép alapértelmezett felhasználója (Linux) vagy Administrator (Windows)',
      password: 'Jelszó',
      passwordHint: 'A generált user-data-ba kerül, amelyet a platform ezután titkosnak nyilvánít: senki sem olvassa vissza',
      sshKeys: 'Nyilvános SSH-kulcsok',
      sshKeysHint: 'Soronként egy (ssh-ed25519 AAAA… megjegyzés)',
      productKey: 'Windows termékkulcs',
      kmsServer: 'KMS-kiszolgáló',
      kmsHint: 'Gazdagép vagy gazdagép:port — termékkulcsot igényel (KMS-ügyfélkulcsot)',
      adDomain: 'Csatlakozás Active Directory-tartományhoz',
      adDomainHint: 'Üres = nincs tartományi csatlakozás',
      adUser: 'Csatlakozási fiók',
      adPassword: 'A csatlakozási fiók jelszava',
      adOu: 'Cél OU (nem kötelező)',
      advanced: 'Haladó: nyers dokumentumok',
      userData: 'user-data (nyers)',
      userDataHint: 'Felülírja a generált user-data-t: a fenti felhasználónak, jelszónak, kulcsoknak és Windows-mezőknek üresen kell maradniuk',
      networkConfig: 'network-config (nyers)',
      networkConfigHint: 'Felülírja a generált hálózatot: a fenti IP-nek, átjárónak és DNS-nek üresen kell maradnia',
      secret: 'A nyers user-data kezelése titkosként',
      secretHint: 'Titkosként megjelölve az API többé senkinek nem adja vissza, és a Checkpointban a masterpass-szal lepecsételve utazik',
      startNow: 'Indítás azonnal',
      startNowHint: 'Minden példány a definiálás után azonnal elindul; a seed ennél az indításnál jön létre'
    },

    create: {
      nicAttachmentNetwork: 'Logikai hálózat (fabric)',
      nicNetwork: 'Logikai hálózat',
      nicNetworkHint: 'Az AJÁNLOTT út (F3): a vNIC a kiszolgáló node SZÁRMAZTATOTT bridge-én valósul meg — a bridge az explicit fabric apply-nál születik, és egy indítás olyan node-on, amely még nem hordozza, beszélve utasít el. Amikor a flotta utolsó hivatkozása elmegy, a bridge a következő apply-nál kiesik.',
      button: 'VM létrehozása',
      title: 'Virtuális gép létrehozása',
      dialogTitle: 'Virtuális gép létrehozása',
      stepGeneral: 'Általános',
      stepGeneralHint: 'Név és profil',
      stepCompute: 'CPU és RAM',
      stepComputeHint: 'Topológia és méretek',
      stepDisks: 'Lemezek',
      stepDisksHint: 'Létrehozás vagy csatlakoztatás',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Meghajtók és adathordozók',
      stepNetwork: 'Hálózat',
      stepNetworkHint: 'NIC-ek: trunk vagy bridge',
      stepSummary: 'Összegzés',
      stepSummaryHint: 'Ellenőrzés és létrehozás',
      name: 'Név',
      nameHint: 'Kisbetűk, számjegyek és kötőjelek (DNS-1123)',
      nextButton: 'Tovább',
      prevButton: 'Vissza',
      submitButton: 'Létrehozás',
      creating: 'Létrehozás…',
      sockets: 'Socketek',
      cores: 'Mag socketenként',
      threads: 'Szál magonként',
      totalVcpus: 'vCPU összesen',
      memoryGib: 'Memória (GiB)',
      cpuModelHint: "A 'host' a host CPU-ját teszi láthatóvá",
      cpuLimitHint: 'Plafon host-magokban — üresen = korlátlan',
      cpuNestedHint: "A vendég számára elérhetővé teszi a vmx/svm-et, hogy saját hipervizort futtathasson — host CPU-modellt és nested-et engedélyező csomópontot igényel",
      newDisk: 'Új lemez',
      attachDisk: 'Meglévő lemez csatlakoztatása',
      diskStorage: 'Tároló',
      diskSize: 'Méret (GiB)',
      diskSelect: 'Lemez',
      addDisk: 'Lemez hozzáadása',
      addCdrom: 'CD/DVD-meghajtó hozzáadása',
      addNic: 'Hálózati interfész hozzáadása',
      remove: 'Eltávolítás',
      slotLimit: 'Slot-korlát elérve',
      cdromImage: 'Lemezkép (üres meghajtó, ha nincs)',
      nicAttachment: 'Csatlakozás',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Nincs (csak tagged)',
      nicTrunkHint: 'Legalább az egyik oldal: egy untagged overlay és/vagy tagged VLAN-leképezések — a VM csak azokon a hostokon futhat, amelyeket minden hivatkozott overlay deklarál',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay-hálózat',
      addTagged: 'Tagged VLAN hozzáadása',
      nicBridge: 'A host-bridge neve',
      nicBridgeHint: 'NM-bridge név szerint — a VM csak azokon a szervereken futhat, amelyek host-hálózata deklarálja ezt a bridge-et',
      nicMac: 'MAC (üresen automatikus)',
      noDisksHint: 'Nincs lemez: a VM-nek csak a hozzáadott CD/DVD-meghajtói lesznek.',
      noCdromsHint: 'Nincs CD/DVD-meghajtó: adj hozzá egyet az ISO-lemezképről indításhoz.',
      mountGuestTools: 'TVirt Guest Tools csatolása az első indításkor',
      mountGuestToolsHint: 'A virtio-drivereket és a guest agentet tartalmazó ISO-t egy üres CD-meghajtóba teszi (ha kell, hozzáadva) — a Windows-telepítőnek szüksége van rá, hogy lássa a lemezeket.',
      noNicsHint: 'Nincs hálózati interfész: a VM konnektivitás nélkül fog elindulni.',
      taggedMappings: 'Tagged VLAN-leképezések',
      summaryDevices: 'Eszközök',
      bootOrderTitle: 'Bootsorrend',
      bootOrderHint: 'Húzd az átrendezéshez — az első bootolható eszköz nyer; a NIC-ek PXE-t indítanak',
      bootOrderUp: 'Mozgatás felfelé',
      bootOrderDown: 'Mozgatás lefelé',
      createError: 'A létrehozás nem sikerült'
    },
    edit: {
      button: 'Szerkesztés',
      title: 'Virtuális gép szerkesztése',
      cancel: 'Mégse',
      save: 'Mentés',
      error: 'A szerkesztés nem sikerült',
      modelStoppedOnly: 'Csak kikapcsolt VM-en módosítható',
      firmwareStoppedOnly: 'A firmware csak kikapcsolt VM-en módosítható — a következő indításkor a gép az új firmware-rel indul, és az UEFI-változók megmaradnak',
      hugePagesStoppedOnly: 'Csak kikapcsolt VM-en módosítható — a következő indításkor a memória az új backinggel születik',
      runningHint: 'A módosítások a következő power cycle-nél lépnek életbe',
      sectionCpu: 'CPU',
      sectionMemory: 'Memória',
      sectionPolicy: 'Szabályzatok'
    },
    devices: {
      networkChip: 'fabric hálózat',
      title: 'Eszközök',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'USB-eszköz hozzáadása',
      addUsbTitle: 'USB-eszközosztály kérése',
      usbClassHint:
        'A VM egy USB-eszköz-OSZTÁLYT kér (egy usb-device címke értékét), sosem egy konkrét eszközt: az indításkor kerül kiválasztásra és lefoglalásra a konkrét szabad eszköz a csomóponton. A regisztrált eszközöket a Klaszter › USB- és PCIe-erőforrások alatt címkézd.',
      usbTag: 'Címke (usb-device)',
      usbValue: 'Az osztály értéke',
      noUsbTags: 'Nincs usb-device címke — hozz létre egyet, és címkézd a regisztrált eszközöket a Klaszter › USB- és PCIe-erőforrások alatt.',
      noUsbValues: 'Ennek a címkének még nincsenek deklarált értékei.',
      usbEmpty: 'Nincs USB-követelmény — adj hozzá egy osztályt, hogy induláskor egy eszköz átadódjon.',
      usbClassChip: 'osztály',
      usbPortChip: 'port',
      usbUnclaimed: 'Nincs lefoglalt eszköz — a VM indulásakor oldódik fel.',
      addGpu: 'GPU hozzáadása',
      addGpuTitle: 'GPU-osztály kérése',
      gpuClassHint:
        'A VM egy GPU-OSZTÁLYT kér (egy gpu-device címke értékét), sosem egy konkrét kártyát: az indításkor kerül kiválasztásra és lefoglalásra a konkrét szabad kártya a csomóponton, és a TELJES IOMMU-csoportja EGYÜTT adódik át. A regisztrált GPU-kat a Klaszter › USB- és PCIe-erőforrások alatt címkézd.',
      gpuTag: 'Címke (gpu-device)',
      gpuValue: 'Az osztály értéke',
      noGpuTags: 'Nincs gpu-device címke — hozz létre egyet, és címkézd a regisztrált GPU-kat a Klaszter › USB- és PCIe-erőforrások alatt.',
      noGpuValues: 'Ennek a címkének még nincsenek deklarált értékei.',
      gpuEmpty: 'Nincs GPU-követelmény — adj hozzá egy osztályt, hogy induláskor egy kártya átadódjon.',
      gpuClassChip: 'osztály',
      gpuGroupChip: 'IOMMU-csoport ×',
      gpuUnclaimed: 'Nincs lefoglalt kártya — a VM indulásakor oldódik fel.',
      gpuPowerCycle: 'Nincs GPU-hotplug — a módosítások a következő power cycle-től érvényesek (PendingRestart)',
      actions: 'Műveletek',
      attachDisk: 'Lemez hozzáadása',
      attachDiskTitle: 'Lemez hozzáadása',
      attach: 'Csatlakoztatás',
      noFreeDisks: 'Nincs nem használt lemez — hozz létre egyet a Virtuális gépek › Nem használt lemezek alatt.',
      addCdrom: 'Meghajtó hozzáadása',
      addCdromTitle: 'CD/DVD-meghajtó hozzáadása',
      editCdromTitle: 'CD/DVD-lemezkép cseréje',
      changeMedia: 'CD/DVD-lemezkép cseréje',
      ejectMedium: 'Kiadás',
      mountGuestTools: 'TVirt Guest Tools csatolása',
      guestToolsMounted: 'TVirt Guest Tools csatolva',
      guestToolsClickMount: 'A TVirt Guest Tools ISO-t az első üres CD/DVD-meghajtóba teszi',
      guestToolsClickUnmount: 'Kattints a kiadáshoz — a meghajtó marad, üresen',
      guestToolsNoSlot: 'Nincs üres CD/DVD-meghajtó — adj hozzá egy meghajtót (vagy adj ki egy adathordozót) a TVirt Guest Tools csatolásához',
      guestToolsSkew: 'Csatolva: v{pinned}; a(z) {node} csomópont most a v{current} verziót szolgálja ki: vedd ki és csatold újra a frissítéshez',
      ejectGuestTools: 'TVirt Guest Tools kiadása (a meghajtó marad, üresen)',
      guestToolsEjectConfirmTitle: 'Kiadod a TVirt Guest Toolst?',
      guestToolsEjectConfirmBody: 'Az adathordozó a bekapcsolt VM-ből kerül kiadásra — a CD/DVD-meghajtó marad, üresen.',
      applyLive: 'Alkalmazás azonnal (a VM be van kapcsolva)',
      addNic: 'Interfész hozzáadása',
      addNicTitle: 'Hálózati interfész hozzáadása',
      editNicTitle: 'Hálózati interfész szerkesztése',
      bridgeChip: 'bridge',
      cable: 'Virtuális kábel',
      plug: 'A virtuális kábel csatlakoztatása',
      unplug: 'A virtuális kábel lecsatlakoztatása',
      remove: 'Eltávolítás',
      removeTitle: 'Eltávolítod: {device}?',
      removeBody: 'Bekapcsolt VM-en a módosítás a következő power cycle-nél lép életbe. A lemezek és lemezképek lecsatlakoznak, sosem törlődnek.'
    }
  }
}
